import React, { useState, useEffect, useContext } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { Table, Modal } from "react-bootstrap";
import BasicPagination from "../../pagination/BasicPagination";
import SVG from "react-inlinesvg";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import { TicketsAndSupportActions } from "../redux/tickets&SupportAction";
import {
  addCommentAsync,
  changeTicketStatusAsync,
  getAllTicketsAsync,
  setComments,
  updateRemainingBudgetAsync,
} from "../redux/tickets&SupportApi";
import ViewTicketSupportManagement from "./viewTicketSupportManagement";
import { toTimestamp } from "../../../utils/appUtils";
import { CircularProgress } from "@material-ui/core";
import { useFormik } from "formik";
import * as Yup from "yup";
import Select from "react-select";
import PerfectScrollbar from "react-perfect-scrollbar";

const TicketSupportManagementTable = () => {
  const dispatch = useDispatch();
  const options = [
    { value: "OPEN", label: "OPEN" },
    { value: "CLOSED", label: "CLOSED" },
  ];

  const perfectScrollbarOptions = {
    wheelSpeed: 1,
    wheelPropagation: false,
  };

  const [DetailsModal, setDetailsModal] = useState(false);

  const {
    refreshAllTickets,
    getAllTicketsList,
    skip,
    limit,
    isLoading,
    selectedTicket,
    comments,
  } = useSelector((state) => state.ticketSupportManagement, shallowEqual);

  //save selected ticket data
  const setSelectedTicket = (ticket) => {
    dispatch(TicketsAndSupportActions.setSelectedTicket(ticket));
  };

  const [forceUpdate, setForceUpdate] = useState(false);

  useEffect(() => {
    setForceUpdate((prev) => !prev); // Toggle state to trigger re-render
  }, [comments]);

  const DetailsClose = () => setDetailsModal(false);
  //on page change
  const onPageChange = (currentBatch) => {
    let count = currentBatch ? currentBatch - 1 : skip;
    dispatch(TicketsAndSupportActions.setTicketBatchNumber(count));
  };
  //save ticket details and show ticket support model
  const DetailsShow = (item) => {
    setSelectedTicket(item);
    setDetailsModal(true);
  };

  const [reply, setReply] = useState(false);
  const handleShowReply = () => setReply(true);
  const handleReply = () => setReply(false);
  //call api for get all tickets
  useEffect(() => {
    if (refreshAllTickets) {
      dispatch(getAllTicketsAsync({ skip, limit }));
    }
  }, [refreshAllTickets, dispatch]);

  const { user } = useSelector((state) => state.auth, shallowEqual);
  //formik validation schema
  const CommentsSchema = () =>
    Yup.object().shape({
      comments: Yup.string()
        .trim()
        .min(1, "Minimum 1 character")
        .max(1000, "Maximum 1000 characters")
        .required("Comment is required"),
    });

  const formik = useFormik({
    initialValues: {
      comments: "",
    },
    enableReinitialize: true,
    validationSchema: CommentsSchema,
    onSubmit: async (values, { resetForm }) => {
      // handleReply();
      dispatch(addCommentAsync(selectedTicket._id, values.comments)).then(
        (response) => {
          if (response?.payload?.data?.commentAdded) {
            // Get the newly added comment
            const newComment = response.payload.data.commentAdded;

            // Dispatch setComments to update Redux state
            dispatch(setComments([...comments, newComment]));
          }
        }
      );

      resetForm();
    },
  });
  //change ticket status
  const onStatusChange = (e) => {
    dispatch(changeTicketStatusAsync(selectedTicket._id, e.value)); //call change ticket status api
  };

  return (
    <>
      <div className="px-6 pt-0 dash_wt_bx pb-0 ovflhddn loader-display-position">
        <div className="tblmrgn mt-0">
          <div className="mt-5">
            <div>
              <Table
                hover
                responsive
                className="mb-0 default_table with_hoverbtn mrpdng_tbl"
              >
                <thead>
                  <tr>
                    <th>Sr No.</th>
                    <th>User Name</th>
                    <th>Subject</th>
                    <th>Raised Date</th>
                    <th>Status</th>
                    <th width="150px">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {getAllTicketsList &&
                  getAllTicketsList.data &&
                  getAllTicketsList.data.supportTickets &&
                  getAllTicketsList.data.supportTickets.length ? (
                    getAllTicketsList.data.supportTickets.map((item, index) => {
                      return (
                        <tr key={index}>
                          <td>
                            <span className="f-w-500">
                              {skip * limit + (index + 1)}
                            </span>
                          </td>
                          <td>
                            {item.userDetails && item.userDetails.userName}
                          </td>
                          <td>{item.subject}</td>
                          <td>{toTimestamp(item.createdAt)}</td>
                          <td>
                            <span
                              className={`pmnt_btn dup-btn-bg text-white ${
                                item.status === "CLOSED"
                                  ? "label label-lg label-light-danger label-inline"
                                  : "label label-lg label-light-success label-inline"
                              }`}
                            >
                              {" "}
                              {item.status}
                            </span>
                          </td>
                          <td>
                            <a
                              title="Edit"
                              className="btn btn-icon btn-light btn-hover-success btn-sm mx-3"
                              onClick={() => DetailsShow(item)}
                            >
                              <span className="svg-icon svg-icon-md svg-icon-dark">
                                <SVG
                                  src={toAbsoluteUrl(
                                    "/media/svg/icons/custom/eye.svg"
                                  )}
                                />
                              </span>
                            </a>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan={8} className="text-center">
                        No Record Found
                      </td>
                    </tr>
                  )}
                  {isLoading && (
                    <tr>
                      <td colSpan={8} className="text-center p-0 border-0">
                        <div className="basic-verification-loader text-center">
                          <CircularProgress />
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>

            <div className="row d-flex align-items-center mr-5 ml-5 mt-4 btm-pagination">
              <div className="col-md-4 mb-5 fn_s_16 f-w-400 text-left">
                Displaying {skip * limit + 1} - {skip * limit + limit} of{" "}
                {getAllTicketsList &&
                  getAllTicketsList.data &&
                  getAllTicketsList.data.recordsTotal}{" "}
                Records
              </div>
              <div className="col-md-8 text-left mb-5 aspgntn">
                <BasicPagination
                  totalRecords={
                    getAllTicketsList &&
                    getAllTicketsList.data &&
                    getAllTicketsList.data.recordsTotal
                  }
                  limit={limit}
                  batch={skip + 1}
                  onBatchChange={onPageChange}
                />
              </div>
            </div>
          </div>
        </div>
        <Modal
          show={DetailsModal}
          onHide={DetailsClose}
          centered
          size="lg"
          className="def_modal"
        >
          <Modal.Header closeButton>
            <Modal.Title className="fn_s_18 color_blk f-w-700">
              Support Ticket Details
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="form def_form frmwtpddng">
              <div className="mb-3 fn_s_18 f-w-400 d-flex align-items-center">
                <span className="text-muted pr-3">Status:</span>
                <div className="viral-events-dropdown ">
                  <Select
                    className={`border-0 p-0 w-150px`}
                    classNamePrefix="phoSelect"
                    options={options}
                    theme={(theme) => ({
                      ...theme,
                      colors: {
                        ...theme.colors,
                        primary25: "#DCF4E4",
                        primary75: "#DCF4E4",
                        primary50: "#DCF4E4",
                        primary: "#50C878",
                      },
                    })}
                    value={{
                      value: selectedTicket.status,
                      label: selectedTicket.status,
                    }}
                    onChange={(e) => onStatusChange(e)}
                  />
                </div>
              </div>

              <p className="fn_s_18 f-w-400 mb-3">
                <span className="text-muted">Subject:</span>{" "}
                {selectedTicket.subject}
              </p>
              <p className="fn_s_18 f-w-400 mb-3">
                <span className="text-muted">Description:</span>{" "}
                {selectedTicket.description}
              </p>
              <div className="re_replySection">
                <PerfectScrollbar
                  className="scroll px-3"
                  options={perfectScrollbarOptions}
                  style={{ maxHeight: "300px", position: "relative" }}
                >
                  <div className="pt-3">
                    {Object.keys(comments).length > 0 &&
                      comments.map((item, index) => (
                        <React.Fragment key={index}>
                          {item.senderId ? (
                            <>
                              <div className="pb-1 f16-400 color_red">
                                {item.senderDetails
                                  ? item.senderDetails.userName
                                    ? item.senderDetails.userName
                                    : item.senderDetails.displayName
                                  : item.senderId && user._id === item.senderId
                                  ? user.displayName
                                  : selectedTicket.userDetails.userName}
                                :
                              </div>
                              <div className="pb-3 f16-400 re_ellips text-white">
                                {item.msg}
                              </div>
                            </>
                          ) : null}
                        </React.Fragment>
                      ))}
                  </div>
                </PerfectScrollbar>
                {selectedTicket.status === "OPEN" && (
                  <>
                    {!reply ? (
                      <button
                        className="btn_new btn-sm px-5"
                        type="button"
                        onClick={handleShowReply}
                      >
                        Reply
                      </button>
                    ) : (
                      <form
                        className="re_replyForm"
                        onSubmit={formik.handleSubmit}
                      >
                        <div className="w-100 pr-3">
                          <input
                            type="text"
                            placeholder="Write here"
                            className="form-control h-auto bg-dark"
                            name="comments"
                            {...formik.getFieldProps("comments")}
                          />
                          {formik.touched.comments && formik.errors.comments ? (
                            <div className="fv-plugins-message-container">
                              <div className="fv-help-block">
                                {formik.errors.comments}
                              </div>
                            </div>
                          ) : null}
                        </div>
                        <button className="btn_new btn-sm " type="submit">
                          Reply
                        </button>
                      </form>
                    )}
                  </>
                )}
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </>
  );
};

export default TicketSupportManagementTable;
